module.exports = __webpack_public_path__ + "img/LogoLoading_circle01.50da39d3.png";